export default function OverridesTablePagination() {
  return {
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          fontSize: '0.875rem',
        },
        displayedRows: {
          fontSize: '0.875rem',
        },
      },
    },
  };
}
